import { PageHeader, Section } from "@/components/site/PageChrome";
import { DownloadSection } from "@/components/site/ClosingBlocks";
import { Target, Eye, Rocket, Heart, MapPin, CheckCircle2 } from "lucide-react";

const roadmap = [
  { phase: "Phase 1", t: "Launch & core modules", d: "Local Needs, Jobs, Marketplace, Shops, Wallet, Blood & SOS — live in first cities.", done: true },
  { phase: "Phase 2", t: "Multi-city expansion", d: "Rolling out to more Indian cities with localised discovery and language support.", done: false },
  { phase: "Phase 3", t: "Deeper business tools", d: "Advanced Shop Pro+ analytics, promotions, and loyalty for local businesses.", done: false },
  { phase: "Phase 4", t: "Community ecosystem", d: "Events, ambassadors, and partnerships that make every city stronger.", done: false },
];

export default function AboutTime2Cash() {
  return (
    <>
      <PageHeader
        eyebrow="About Time2Cash"
        title="Everything local, one app."
        subtitle="Time2Cash exists to put your entire city in your pocket — connecting people, businesses, jobs, and safety in one trusted local platform."
      />

      <Section>
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#FF5A00]/10 rounded-[2rem] rotate-2" />
            <img
              src="Media-Library/h3.png"
              alt="Indian city life"
              className="relative rounded-[2rem] w-full aspect-[4/3] object-cover shadow-xl"
            />
          </div>
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918]">Our story.</h2>
            <p className="mt-4 text-[#4A4846] leading-relaxed">
              City life means juggling a dozen apps — one to find help, another for jobs, another to buy or sell, more for local shops.
              Time2Cash was born from a simple idea: your neighbourhood should live in a single, trusted app.
            </p>
            <p className="mt-4 text-[#4A4846] leading-relaxed">
              We built Time2Cash for everyday India — the shop owner who wants more customers, the student looking for a part-time gig,
              the family that needs a quick repair, and the community that shows up during emergencies.
            </p>
          </div>
        </div>
      </Section>

      <Section className="bg-[#FFF9F5]">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { icon: Eye, t: "Vision", d: "To become the digital heartbeat of every Indian city — where local life just works." },
            { icon: Target, t: "Mission", d: "Connect people, businesses, and opportunities locally, transparently, and without middlemen." },
            { icon: Heart, t: "Values", d: "Community-first, transparent by default, and built for real everyday needs." },
          ].map(({ icon: Icon, t, d }) => (
            <div key={t} className="rounded-3xl border border-[#EBE8E3] bg-white p-7">
              <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center">
                <Icon className="w-6 h-6 text-[#FF5A00]" />
              </div>
              <h3 className="mt-4 text-xl font-bold text-[#1A1918]">{t}</h3>
              <p className="mt-2 text-[#4A4846]">{d}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section>
        <div className="flex items-center gap-2 text-[#FF5A00] font-semibold text-sm">
          <Rocket className="w-4 h-4" /> Roadmap
        </div>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold text-[#1A1918]">Where we&apos;re headed.</h2>
        <div className="mt-10 space-y-4">
          {roadmap.map((r) => (
            <div key={r.phase} className="flex gap-4 rounded-3xl border border-[#EBE8E3] bg-white p-6">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${r.done ? "bg-emerald-100" : "bg-[#FFF3ED]"}`}>
                {r.done ? <CheckCircle2 className="w-5 h-5 text-emerald-600" /> : <MapPin className="w-5 h-5 text-[#FF5A00]" />}
              </div>
              <div>
                <div className="text-xs font-semibold text-[#FF5A00]">{r.phase}</div>
                <div className="font-bold text-[#1A1918]">{r.t}</div>
                <p className="mt-1 text-sm text-[#4A4846]">{r.d}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <DownloadSection />
    </>
  );
}
